import { InjectionToken } from '@angular/core';
export const URL_CONSTANTS = {
    ADMIN: {
        CREATE_SUPER_ADMIN: 'create_superadmin',
        ADMIN_LOGIN: 'superadmin_login',
        PROFILE_UPDATE: 'superadmin_profile_update',
        CHANGE_PASSWORD: 'superadmin_change_password',
        VIEW_ADMIN_DETAILS: 'view_superadmin_details',

        ADD_COUNTRY: 'add_country',
        VIEW_ALL_COUNTRIES: 'view_all_countries',
        VIEW_SINGLE_COUNTRY: 'single_view_country',
        UPDATE_COUNTRY: 'update_country',
        DELETE_COUNTRY: 'delete_country',
        UPDATE_COUNTRY_STATUS: 'country_update_status',

        VIEW_ALL_ACCESS_COUNTRIES: 'view_all_countries_list',

        ADD_STATE: 'add_state',
        VIEW_ALL_STATES: 'view_all_states',
        VIEW_SINGLE_STATE: 'single_view_state',
        UPDATE_STATE: 'update_state',
        DELETE_STATE: 'delete_state',
        UPDATE_STATE_STATUS: 'update_state_status',

        ADD_CITY: 'add_city',
        VIEW_ALL_CITIES: 'view_all_cities',
        VIEW_SINGLE_CITY: 'single_view_city',
        UPDATE_CITY: 'update_city',
        DELETE_CITY: 'delete_city',
        UPDATE_CITY_STATUS: 'update_city_status',

        ADD_COMPANY_TYPE: 'add_company',
        UPDATE_COMPANY_TYPE: 'update_company_type',
        VIEW_SINGLE_COMAPNY_TYPE: 'single_view_companytype',
        VIEW_ALL_COMPANY_TYPES: 'view_all_companytypes',
        DELETE_COMPANY_TYPE: 'delete_company_type',

        ADD_ENTITY_ENDING: 'add_entity_ending',
        UPDATE_ENTITY_ENDING: 'update_entity_ending',
        VIEW_SINGLE_ENTITY_ENDING: 'single_view_entity_ending',
        VIEW_ALL_ENTITY_ENDING: 'view_all_entity_ending',
        DELETE_ENTITY_ENDING: 'delete_entity_ending',

        ADD_INDUSTRY: 'add_industry',
        UPDATE_INDUSTRY: 'update_industry',
        VIEW_SINGLE_INDUSTRY: 'single_view_industry',
        VIEW_ALL_INDUSTRIES: 'view_all_industry',
        DELETE_INDUSTRY: 'delete_industry',

        ADD_PROJECT_INFO: 'add_project_info',
        UPDATE_PROJECT_INFO: 'update_project_info',
        VIEW_SINGLE_PROJECT_INFO: 'single_view_project_info',
        VIEW_ALL_POJECT_INFO: 'view_all_project_info',
        DLETE_PROJECT_INFO: 'delete_project_info',

        ADD_CATEGORY: 'add_category',
        UPDATE_CATEGORY: 'update_category',
        VIEW_SINGLE_CATEGORY: 'single_view_categories',
        VIEW_ALL_CATEGORIES: 'view_all_categories',
        DELETE_CATEGORY: 'delete_category',

        ADD_FAQS: 'add_faq',
        UPDATE_FAQS: 'update_faq',
        VIEW_SINGLE_FAQS: 'single_view_faq',
        VIEW_ALL_FAQS: 'view_all_faqs',
        DLEETE_FAQS: 'delete_faq',

        ADD_QUESTION_AND_ANSWER: 'add_question_and_answer',
        UPDATE_QUESTION_AND_ANSWER: 'update_question_and_answer',
        VIEW_SINGLE_QUESTION_AND_ANSWER: 'single_view_questions_and_answers',
        VIEW_ALL_QUESTION_AND_ANSWERS: 'view_all_questions_and_answers',
        DELETE_QUESTION_AND_ANSWER: 'delete_questions_and_answers',

        ADD_TESTIMONIAL: 'add_testimonials',
        EDIT_TESTIMONIAL: 'update_testimonials',
        VIEW_SINGLE_TESTIMONIAL: 'single_view_testimonials',
        VIEW_ALL_TESTIMONIALS: 'view_all_testimonials',
        DELETE_TESTIMONIAL: 'delete_testimonials',

        ADD_BLOG: 'add_blog',
        EDIT_BLOG: 'update_blog',
        VIEW_SINGLE_BLOG: 'single_view_blog',
        VIEW_ALL_BLOGS: 'view_all_blog',
        DELETE_BLOG: 'delete_blog',

        ADD_CMS: 'add_cms',
        EDIT_CMS: 'update_cms',
        VIEW_SINGLE_CMS: 'single_view_cms',
        VIEW_ALL_CMS: 'view_all_cms',
        DELETE_CMS: 'delete_cms',

        ADD_STARTUP: 'add_startups',
        EDIT_STARTUP: 'update_startups',
        VIEW_SINGLE_STARTUP: 'single_view_startups',
        VIEW_ALL_STARTUPS: 'view_all_startups',
        DELETE_STARTUP: 'delete_startups',

        ADD_OUR_SERVICES: 'add_our_services',
        UPDATE_OUR_SERVICES: 'update_our_services',
        SINGLE_VIEW_OUR_SERVICES: 'single_view_our_services',
        VIEW_ALL_OUR_SERVICES: 'view_all_our_services',
        DELETE_OUR_SERVICES: 'delete_our_services',

        VIEW_US_ADDRESS: 'view_us_address',
        UPDATE_US_ADDRESS: 'add_and_update_usadress',


        ADD_COMPANY_STATES: 'add_company_states',
        EDIT_COMPANY_STATES: 'update_company_states',
        VIEW_COMPANY_STATE: 'single_view_company_states',
        VIEW_ALL_COMPANY_STATES: 'view_all_company_states',
        DELETE_COMPANY_STATES: 'delete_company_states',

        VIEW_ALL_NEWS_LETTERS: 'view_all_news_letters',
        DELETE_NEWS_LETTER: 'delete_newsletter',

        VIEW_ALL_COMPANIES: 'view_all_companies',
        GET_SINGLE_COMPANY: 'view_companies',
        CHANGE_COMPANY_PAYMENT_STATUS: 'update_paymentstatus',

        ADD_BUILTS: 'add_builts',
        EDIT_BUILTS: 'update_builts',
        VIEW_BUILT: 'single_view_built',
        VIEW_ALL_BUILTS: 'view_all_built',
        DELETE_BUILTS: 'delete_built',

        ADD_PLANS: 'add_plans',
        EDIT_PLANS: 'update_plans',
        VIEW_PLAN: 'single_view_plan',
        VIEW_ALL_PLANS: 'view_all_plans',
        DELETE_PLANS: 'delete_plan',

        ADD_SOCIAL_MEDIA: 'add_social_media',
        EDIT_SOCIAL_MEDIA: 'update_social_media',
        VIEW_SOCIAL_MEDIA: 'single_view_social_media',
        VIEW_ALL_SOCIAL_MEDIA: 'view_all_social_media',
        DELETE_SOCIAL_MEDIA: 'delete_social_media',

        VIEW_ALL_COUNTS: 'view_all_counts',

        VIEW_ALL_CUSTOMER_LIST: 'view_all_customers',

        ADD_DOCUMENT_TYPE: 'add_document',
        EDIT_DOCUMENT_TYPE: 'update_document',
        VIEW_DOCUMENT_TYPE: 'single_view_document',
        VIEW_ALL_DOCUMENTS_TYPES: 'view_all_documents',
        DELETE_DOCUMENT_TYPE: 'delete_document',
        VIEW_ALL_CONTACTUS: 'view_all_contactus',
        VIEW_ALL_OURSERVICES_TRANSACTIONS: 'view_all_ourservices_transactions',
        VIEW_ALL_ENQUIRES: 'view_all_enquires',
        SINGLE_VIEW_ENQUIRY: 'single_view_enquires',

        VIEW_ALL_PLAN_DURATIONS: 'view_all_plan_durations',
        ADD_PLAN_DURAATION: 'add_plan_duration',
        EDIT_PLAN_DURATION: 'update_plan_duration',
        DELETE_PLAN_DURATION: 'delete_plan_duration',
        VIEW_SINGLE_PLAN_DURATION: 'single_view_plan_duration',

        ADD_ADMIN_DOCUMENT: 'add_admin_document',
        EDIT_ADMIN_DOCUMENT: 'update_admin_document',
        VIEW_ADMIN_DOCUMENT: 'single_view_admin_document',
        VIEW_ALL_ADMIN_DOCUMENTS: 'view_all_admin_documents',
        DELETE_ADMIN_DOCUMENT: 'delete_admin_document',

        ADD_ADMIN_DOCUMENTS: 'add_admin_documents',
        ACCEPT_REJECT_FRONT_END_DOCUMENTS: 'documents_accept_reject',
        UPDATE_COMPANY: 'update_company',

        GET_AVAILABLE_PLAN_DURATIONS: 'get_available_plan_durations',

        ADD_TAX_SERVICE: 'add_tax_service',
        EDIT_TAX_SERVICE: 'update_tax_service',
        VIEW_ALL_TAX_SERVICES: 'get_available_tax_services',
        DELETE_TAX_SERVICE: 'delete_tax_service',
        ACTIVATE_TAX_SERVICE: 'activate_tax_service',
        DEACTIVATE_TAX_SERVICE: 'deactivate_tax_service',
        VIEW_SINGLE_TAX_SERVICE: 'single_tax_services',

        ADD_TAX_SERVICE_QUESTION: 'add_tax_services_questions',
        EDIT_TAX_SERVICE_QUESTION: 'update_tax_services_questions',
        VIEW_ALL_TAX_SERVICE_QUESTIONS: 'get_tax_questions',
        DELETE_TAX_SERVICE_QUESTION: 'delete_tax_services_questions',
        ACTIVATE_TAX_SERVICE_QUESTION: 'activate_tax_service_question',
        DEACTIVATE_TAX_SERVICE_QUESTION: 'deactivate_tax_service_question',
        VIEW_SINGLE_TAX_SERVICE_QUESTION: 'single_tax_services_questions',

        GET_TAX_QUESTIONS_RESPONSES: 'get_tax_questions_responses',
        GET_SINGLE_TAX_RESPONSE: 'get_customer_tax_questions_responses',
    },
    USER: {
        SINGUP_CUSTOMER: 'singup_customer',
        CUSTOMER_LOGIN: 'customer_login',
        CUSTOMER_CHANGE_PASSWORD: 'customer_change_password',
        VIEW_CUSTOMER_PROFILE: 'view_customer_profile',
        CUSTOMER_PASSWORD_RESET: 'customer_password_reset',
        CUSTOMER_FORGOT_PASSWORD: 'customer_forgot_password',
        CUSTOMER_PROFILE_UPDATE: 'customer_profile_update',
    },
    FRONTEND: {
        ADD_COMPANIES: 'add_companies',
        ACTIVE_ALL_ENTITY_ENDING: 'active_all_entity_ending',
        ACTIVE_ALL_INDUSTRY: 'active_all_industry',
        VIEW_COMPANYIES_CITIZEN: 'view_companies_citizen',
        ACTIVE_ALL_COUNTRIES: 'active_all_countries',
        ACTIVE_ALL_CITIES: 'active_all_cities',
        VIEW_ALL_COMPANY_STATES: 'view_all_company_states',
        ACTIVE_ALL_STATES: 'active_all_states',
        VIEW_ALL_QUESTIONS_AND_ANSWERES: 'view_all_questions_and_answers',
        ADD_ENQUIRY: 'add_enquiry',
        VIEW_SINGLE_COMPANY: 'view_companies',
        VIEW_ALL_COMPAPNYS: 'view_all_companies',
        VIEW_US_ADDRESS: 'view_us_address',
        VIEW_ALL_FAQS: 'view_all_faqs',

        VIEW_SINGLE_FRONT_END_OURSERVICE: 'single_view_our_services',
        VIEW_ALL_DOCUMENTS: 'view_all_documents',
        ADD_DOCUMENTS: 'add_documents',
        ADD_TRANSACTION: 'add_transaction',
        VIEW_PAYMENTS: 'view_payments',
        BUY_NEW_SERVICE: 'buy_new_service',
        ADD_CONTACTUS: 'add_contactus',
        ADD_NEWS_LETTER: 'add_news_letters',
        VIEW_ALL_OURSERVICES_TRANSACTIONS: 'view_all_ourservices_transactions',
        VIEW_CMS_BASEDON_TITLE: 'view_cms_basedon_title',
        VIEW_ALL_ADMIN_DOCUMENTS: 'view_all_basedon_document_type',
    },
    USERS: {
        VIEW_ALL_HOME: 'view_all_home',
    },
};
export const URL_CONSTANTS_TOKEN = new InjectionToken<any>(
    'url_constants',
);
